export default __webpack_public_path__ + "static/media/rupay.2b71a00f.svg";